// extracted by mini-css-extract-plugin
export default {"logo":"client-logo-mobile_logo__xUD5g"};